import { gql } from '@apollo/client';

import STUDENT_FRAGMENT from '../fragments/student';
import STUDENT_LICENSE_USAGE_FRAGMENT from '../fragments/student-license-usage';

/**
 * If this query becomes the default, we should just add the license usage fragment
 * onto the student query
 */
const GET_STUDENT_WITH_LICENSE_USAGE = gql`
  query getStudentWithLicenseUsageQuery($where: StudentWhereInput!) {
    student(where: $where) {
      ...BaseStudent
      licenseUsage {
        ...BaseStudentLicenseUsage
      }
    }
  }
  ${STUDENT_FRAGMENT}
  ${STUDENT_LICENSE_USAGE_FRAGMENT}
`;

export default GET_STUDENT_WITH_LICENSE_USAGE;
